import {cartRegister} from "./cartRegister";
import {flowRegister} from "./flowRegister";
import queryString from "query-string";
import {dataRegister} from "./dataRegister";
import {imagesRegister} from "./imagesRegister";
import {themeRegister} from "./themeRegister";
import {salesChannelRegister} from "./salesChannelRegister";
import {userRegister} from "./userRegister";
import {agentRegister} from "./agentRegister";
import {langRegister} from "./langRegister";
import {collectedRegister} from "./collectedRegister";
const hash = require('object-hash');

class canvasRegister {

    static facebook = {hash: null, url: null, height: 620, width: 1200};
    static instagram = {hash: null, url: null, height: 1080, width: 1080};

    static create(key){
        let url = canvasRegister.url(key);
        let hash_code = null;
        if(canvasRegister[key].hash){
            hash_code = canvasRegister[key].hash;
        }else{
            try {
                if(JSON.parse(sessionStorage.getItem("canvas-"+key)).hash){
                    hash_code = JSON.parse(sessionStorage.getItem("canvas-"+key)).hash;
                }
            }catch (e) {}
        }
        if(hash_code !== hash(url)){

            let width = canvasRegister[key].width;
            let height = canvasRegister[key].height;

            if (collectedRegister.getValue("custom_creative")) {
                width = 1080;
                height = 1080;
            }

            dataRegister.createSlide({url: url, width: width, height: height}).then((response) => {
                canvasRegister.set(response.url, hash(url), key);
            }, (error) => {
                canvasRegister.set(null, null, key);
            });
        }
    }

    static url(key){
        let data = themeRegister.getValue();
        let theme = themeRegister.getTheme();
        let images = imagesRegister.get();
        let cart = cartRegister.get();
        let slides = [];
        let main_image = null;
        let one_image = null;
        let two_image = null;
        let three_image = null;
        for (let i = 0; i < images.length; i++) {
            if (images[i].label && slides.length < 9) {
                let slide = {
                    small: images[i].images.small,
                    large: images[i].images.large
                };
                slides.push(slide);
            }
        }
        if (cart.admin_image) {
            main_image = cart.admin_image.images.large;
        }
        if (slides[0]) {
            one_image = slides[0].small;
        }
        if (slides[1]) {
            two_image = slides[1].small;
        }
        if (slides[2]) {
            three_image = slides[2].small;
        }

        if (collectedRegister.getValue("custom_creative")) {

            let data_custom_creative = {};

            data_custom_creative.main_image = main_image;
            data_custom_creative.one_image = one_image;
            data_custom_creative.two_image = two_image;
            data_custom_creative.three_image = three_image;

            let theme_data = themeRegister.getValue();
            if(theme_data && theme_data.theme_region){
                if (langRegister.lang() === "sv") {
                    data_custom_creative.agent_description = "Expert på " + theme_data.theme_region;
                } else {
                    data_custom_creative.agent_description = theme_data.theme_region + " Expert";
                }
            }

            let user_data = userRegister.getUser();
            let agent_data = agentRegister.get();
            if(user_data && user_data.branding_pref){
                data_custom_creative.branding_image = user_data.branding_image;
            }

            try {

                data_custom_creative.type = JSON.parse(collectedRegister.getValue("type")).title;
                //TODO: type_default only tested in EN and SE lang, other langs need to be tested
                data_custom_creative.type_default = JSON.parse(collectedRegister.getValue("type")).title + " " + collectedRegister.getValue("offering");
                data_custom_creative.offering = collectedRegister.getValue("offering");

                if (theme === "promotion") {
                    data_custom_creative.slogan = theme_data.slogan_offer;
                } else {
                    data_custom_creative.slogan = theme_data.slogan_validation;
                }

                if (collectedRegister.getValue("listing_type").indentifier === "sale") {
                    data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("status")).title;
                } else {
                    data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("furnishings")).title;
                }

                data_custom_creative.slogan_promo = theme_data.slogan_offer;
                data_custom_creative.slogan_calltoaction = theme_data.slogan_action;

                data_custom_creative.area = theme_data.theme_region;
                data_custom_creative.building = collectedRegister.getValue("google").autocomplete_address;
                data_custom_creative.city = collectedRegister.getValue("display_region").name;

                data_custom_creative.size = collectedRegister.getValue("size_custom");
                data_custom_creative.beds = JSON.parse(collectedRegister.getValue("bed")).title;
                data_custom_creative.baths = JSON.parse(collectedRegister.getValue("bath")).title;
                data_custom_creative.price = theme_data.last_title;

            } catch (e) {}

            try {
                if (collectedRegister.getValue("contact").permit) {
                    data_custom_creative.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("qrcode_ads")) {
                    data_custom_creative.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                }
            } catch (e) {}

            if(agent_data && agent_data.profile_image){
                if(agent_data && agent_data.profile_image){
                    data_custom_creative.agent_image = agent_data.profile_image;
                }
                if(agent_data && agent_data.name){
                    data_custom_creative.agent_name = agent_data.name;
                }
            }else{
                if(user_data && user_data.profile_image){
                    data_custom_creative.agent_image = user_data.profile_image;
                }
                if(user_data && user_data.logo_image){
                    data_custom_creative.agency_image = user_data.logo_image;
                }
                if(user_data && user_data.name){
                    data_custom_creative.agent_name = user_data.name;
                }
            }

            let query = queryString.stringify(data_custom_creative);

            let link = "https://coral-app-xg6gr.ondigitalocean.app/" + collectedRegister.getValue("reseller_name") + "/canvas/" + theme + "/first/1_1/?" + query + "&legacy=false";

            return link;

        } else {

            data.main_image = main_image;
            data.one_image = one_image;
            data.two_image = two_image;
            data.three_image = three_image;


            let theme_data = themeRegister.getValue();
            if(theme_data && theme_data.theme_region){
                if (langRegister.lang() === "sv") {
                    data.agent_description = "Expert på " + theme_data.theme_region;
                } else {
                    data.agent_description = theme_data.theme_region + " Expert";
                }
            }

            let user_data = userRegister.getUser();
            let agent_data = agentRegister.get();
            if(user_data && user_data.branding_pref){
                data.primary_color = user_data.branding_pref.primary_color;
                data.secondary_color = user_data.branding_pref.secondary_color;
                data.branding_image = user_data.branding_image;
            }

            try {
                if(user_data && user_data.branding_pref){
                    data.disable_infobox = user_data.branding_pref.disable_infobox ? user_data.branding_pref.disable_infobox : false;
                    data.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                    data.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                    data.opacity_infobox = user_data.branding_pref.opacity_infobox ? user_data.branding_pref.opacity_infobox : false;
                }
            } catch (e) {}


            if(user_data && user_data.logo_image){
                data.agency_image = user_data.logo_image;
            }
            if(!data.agent_description && user_data.company_name){
                data.agent_description = user_data.company_name;
            }
            if(!data.agent_description && user_data.billing_company){
                data.agent_description = user_data.billing_company;
            }

            if(agent_data && agent_data.profile_image){
                if(agent_data && agent_data.profile_image){
                    data.agent_image = agent_data.profile_image;
                }
                if(agent_data && agent_data.email){
                    try{
                        let split_email = agent_data.email.split("@");
                        if(Array.isArray(split_email) && split_email.length > 1){
                            data.agency_website = split_email[1];
                        }
                    }catch (e) {}
                }
                if(agent_data && agent_data.name){
                    data.agent_name = agent_data.name;
                }
                if (user_data.fallback_pref && user_data.fallback_pref.phone) {
                    data.agent_phone = user_data.phone;
                } else {
                    if (agent_data && agent_data.phone) {
                        data.agent_phone = agent_data.phone;
                    }
                }
            }else{
                if(user_data && user_data.profile_image){
                    data.agent_image = user_data.profile_image;
                }
                if(user_data && user_data.logo_image){
                    data.agency_image = user_data.logo_image;
                }
                if(user_data && user_data.email){
                    try{
                        let split_email = user_data.email.split("@");
                        if(Array.isArray(split_email) && split_email.length > 1){
                            data.agency_website = split_email[1];
                        }
                    }catch (e) {}
                }
                if(user_data && user_data.name){
                    data.agent_name = user_data.name;
                }
                if(user_data && user_data.phone){
                    data.agent_phone = user_data.phone;
                }
            }

            try {
                if (collectedRegister.getValue("contact").permit) {
                    data.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("qrcode_ads")) {
                    data.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                }
            } catch (e) {}

            let query = queryString.stringify(data);

            let link = "https://preview." + dataRegister.domain + "/" + salesChannelRegister.get("name") + "/canvas/" + theme + "/first/"+key+"?" + query;

            return link;

        }
    }

    static set(value, hash, key){
        canvasRegister[key].url = value;
        canvasRegister[key].hash = hash;
        try {
            sessionStorage.setItem("canvas-"+key, JSON.stringify(canvasRegister[key]));
        }catch (e) {}
    }

    static get(key){
        if(canvasRegister[key].url && canvasRegister[key].hash){
            return canvasRegister[key];
        }else{
            try {
                if(JSON.parse(sessionStorage.getItem("canvas-"+key)).hash && JSON.parse(sessionStorage.getItem("canvas-"+key)).url){
                    return JSON.parse(sessionStorage.getItem("canvas-"+key));
                }
            }catch (e) {}
        }
    }

    static remove(){
        canvasRegister.facebook = {hash: null, url: null, height: collectedRegister.getValue("custom_creative") ? 1080 : 620, width: collectedRegister.getValue("custom_creative") ? 1080 : 1200};
        canvasRegister.instagram = {hash: null, url: null, height: 1080, width: 1080};
        try {
            sessionStorage.removeItem("canvas-facebook");
            sessionStorage.removeItem("canvas-instagram");
        }catch (e) {}
    }

}

export {canvasRegister}


// WEBPACK FOOTER //
// ./src/services/canvasRegister.js